import script from "./ComHonor.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComHonor.vue?vue&type=script&setup=true&lang=ts"

import "./ComHonor.vue?vue&type=style&index=0&id=d9d965fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9d965fa"]])

export default __exports__